import { makeStyles } from "tss-react/mui"
import { Radio, RadioGroup, FormControlLabel, Typography, Stack } from "@mui/material"
import { LocalizedStrict } from "../../../../../../localization/components/AppLocalized"
import { ColorOption } from "../../../shopsTypes"

const useStyles = makeStyles()((theme) => ({
    baseColor: {
        color: theme.palette.text.primary,
    },
    wrap: {
        border: "1px solid transparent",
        padding: "0.2rem",
        borderRadius: "50%",
        transition: "all ease-out 0.3s",
        margin: 0,
    },
    wrapSelected: {
        borderColor: theme.palette.tailwind.slate[700],
    },
    colorRadio: {
        color: theme.palette.common.white,
        "&.Mui-checked": {
            color: theme.palette.common.white,
        },
        "&:hover": {
            backgroundColor: "transparent",
        },
        padding: 0,
        width: "1.835rem",
        height: "1.835rem",
        borderRadius: "50%",
    },
}))

type SelectColorProps = {
    list: ColorOption[]
    selectedColor: ColorOption | undefined
    handleSelectColor: (el: ColorOption) => void
}

export const SelectColor = ({ list, selectedColor, handleSelectColor }: SelectColorProps) => {
    const { classes, cx } = useStyles()

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const value = list.find((el) => el.value === event.target.value)
        value && handleSelectColor(value)
    }

    return (
        <Stack direction="row" alignItems="center" spacing="1rem">
            <LocalizedStrict id="merchant-shop-form-hardware-packages-color">
                <Typography variant="body2" className={classes.baseColor}>
                    Color:
                </Typography>
            </LocalizedStrict>
            <RadioGroup row value={selectedColor ? selectedColor.value : selectedColor} onChange={handleChange}>
                <Stack direction="row" alignItems="center" spacing="0.5rem">
                    {list.map((option) => (
                        <FormControlLabel
                            key={option.value}
                            value={option.value}
                            control={
                                <Radio
                                    className={classes.colorRadio}
                                    style={{ color: option.color, backgroundColor: option.color }}
                                />
                            }
                            label=""
                            className={cx(
                                classes.wrap,
                                selectedColor && selectedColor.value === option.value ? classes.wrapSelected : "",
                            )}
                        />
                    ))}
                </Stack>
            </RadioGroup>
        </Stack>
    )
}
